import { api } from 'app/api';

/**
 * @param {{ hspId:string, mpiKey:string, receivePaymentId:string, medicalInsuranceType:string }} params
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export const getPayDetailStatementCheck = ({ hspId, mpiKey, receivePaymentId, medicalInsuranceType }) => {
  return api.get(
    `/dfd/api/if/web/v1/pay-detail-statement-check/${hspId}/${mpiKey}/${receivePaymentId}?medicalInsuranceType=${medicalInsuranceType}`,
  );
};

export const getPayDetailStatementItem = ({ hspId, mpiKey, receivePaymentId, medicalInsuranceType }) => {
  return api.get(
    `/dfd/api/if/web/v1/pay-detail-statement-item/${hspId}/${mpiKey}/${receivePaymentId}?medicalInsuranceType=${medicalInsuranceType}`,
  );
};

export const postPayDetailStatementRequest = ({ hspId, mpiKey, receivePaymentId, medicalInsuranceType }) => {
  return api.post(`/dfd/api/if/web/v1/pay-detail-statement-request`, {
    hspId,
    mpiKey,
    receivePaymentId,
    medicalInsuranceType,
  });
};

/**
 * PDF 생성을 위한 API 호출
 * @param {{ html: string }} data - HTML 데이터
 * @returns {Promise<string>} fileId
 */
export const postPayDetailStatementPdf = ({ html }) => {
  return api.post(`/dfd/api/if/web/v1/pay-detail-statement-pdf`, { html });
};

/**
 * PDF 다운로드를 위한 API 호출
 * @param {string} fileId - fileId
 * @returns pdf 다운로드 링크
 */
export const getPayDetailStatementPdfDownloadUrl = ({ fileId }) => {
  return api.get(`/dfd/api/if/web/v1/pay-detail-statement-download/${fileId}`);
};
